module.exports = __webpack_public_path__ + "static/media/recall-loading.1e55fecd.gif";